module.exports = __webpack_public_path__ + "static/img/Kozay.a5be269.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Kozay.jpg
// module id = pzLu
// module chunks = 1